<template>
  <div class="bg-white-primary py-3 mb-2 w-100">
    <div class="mt-2 text-center">
      <div class="d-flex justify-content-center">
        <div class="d-md-flex justify-content-md-center mb-2 gap-3 w-100">
          <div
            class="col-12 col-md-auto d-flex justify-content-start justify-content-md-center align-items-center border border-opacity-75 rounded py-0d8 min-w-md-280x size-14"
          >
            <div class="d-block d-md-none pe-3 ml-sm-2d5"></div>
            <label class="text-secondary" for="platformAgent">社内SE転職ナビ エージェント</label>
          </div>
          <div
            class="col-12 col-md-auto d-flex align-items-center border border-opacity-75 border-info rounded py-0d8 ps-4 min-w-md-280x size-14 fw-bold mt-3 mt-md-0"
          >
            <img
              src="@/assets/image/check-primary.svg"
              alt="image"
              class="img-fluid pe-3"
              style="max-width: 80px"
            />
            <label for="platformDirect">社内SE転職ナビ ダイレクト</label>
          </div>
        </div>
      </div>

      <div class="mt-4 bg-green-01 rounded">
        <h6 class="fw-bold pt-3">社内SE転職ナビ エージェントについて</h6>
        <p class="mx-4 text-center">
          <!-- For desktop -->
          <span class="d-none d-md-inline">
            社内SE転職ナビ
            エージェントでは、転職のプロフェッショナルである弊社エージェントがあなたの転職を全力でサポートいたします。
          </span>

          <!-- For mobile -->
          <span class="d-md-none">
            社内SE転職ナビ
            エージェントでは、転職のプロフェッショナルである弊社エージェントがあなたの転職を全力でサポートいたします。
          </span>
        </p>
        <a
          class="btn btn-primary px-3 mt-2 mb-4 text-white rounded-pill size-12"
          @click="showModal"
        >
          キャリアカウンセリングを受けてみる
        </a>
      </div>
    </div>
  </div>

  <teleport to="body">
    <div id="platformAgentModal" ref="modal" class="modal fade">
      <div class="modal-dialog modal-dialog-top">
        <div class="modal-content rounded-4 overflow-hidden min-w-md-560x">
          <div class="modal-body p-0 overflow-x-hidden">
            <div class="d-flex flex-column">
              <div class="row bg-green-01 mb-2">
                <div class="d-flex justify-content-end pt-2 ms-3 position-absolute">
                  <button role="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div
                  class="d-flex justify-content-center align-items-center mw-sm-90pct ps-sm-4r py-3"
                >
                  <img
                    src="@/assets/images/girl-1.png"
                    alt="image"
                    class="img-fluid"
                    style="max-width: 60px"
                  />
                  <h6 class="fw-bold text-info mb-0 ms-3 me-3">
                    キャリアカウンセリングを受けてみませんか？
                  </h6>
                </div>
              </div>

              <div class="text-start px-3 px-md-4 py-3 color-black-02">
                <div class="px-2">
                  <p>
                    「社内SE転職ナビエージェント」をご利用いただくと、弊社エージェントがあなたのご経歴、ご希望条件をもとにマッチした求人をご提案。また、書類の添削、事前面接対策などあなたの転職成功までサポートしていきます。ダイレクトサービスと並行してご利用できますので、ぜひご利用ください。
                  </p>
                  <p>「社内SE転職ナビ　エージェント」の詳細についてはこちら</p>
                  <p>
                    ※「社内SE転職ナビ　エージェント」は、これまでのご経験やご希望内容によっては、残念ながらサービスのご提供ができない場合がございます。あらかじめご了承ください。
                  </p>
                  <p>ご利用される場合は利用規約をご確認・ご同意の上、利用開始してください。</p>
                </div>
              </div>

              <div class="d-flex justify-content-center pb-5">
                <a
                  class="btn btn-primary rounded px-4 py-2 text-white size-13"
                  @click="redirectToTeaser"
                >
                  エージェントサービスのご紹介
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { TEASER_PATH } from '@/constant/routers/path';
import { Modal } from 'bootstrap';
import { onMounted, ref } from 'vue';

const modal = ref<HTMLElement | null>(null);

const showModal = (): void => {
  if (modal.value) {
    const bsModal = new Modal(modal.value);
    bsModal.show();
  }
};

const redirectToTeaser = (): void => {
  localStorage.setItem('prePathOfTeaser', `${window.location.pathname}${window.location.search}`);
  window.location.href = TEASER_PATH;
};

onMounted((): void => {
  modal.value = document.getElementById('platformAgentModal');
});
</script>
